import { reportException, Severity, SkywardException } from "#skyward_error";
import { showErrorDialog } from "#skyward_modalLayer";
import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";

export interface AjaxErrorLog
{
    message: string;
    severity: Severity | "";
    primaryKey: number | null;
    showViewLog?: boolean; // unused
    clientIdentifier?: string;
};

const skyward = window.skyward;

let invalidSessionDialogOpen = false;

$(document).ajaxError(processAjaxError);

const events =
{
    dialog
}

registerEvents("error", events);

export function processAjaxError(_event: JQuery.TriggeredEvent, jqXHR: JQuery.jqXHR, settings: JQuery.AjaxSettings)
{
    if (settings != null && (settings.suppressErrors === true || typeof settings.suppressErrors === "function" && settings.suppressErrors(jqXHR)))
    {
        return;
    }

    switch (jqXHR.status)
    {
        case 401:
            //Unauthorized
            if (jqXHR.responseText === "Invalid session")
            {
                // Reload the page so that we get redirected to sign-in from a normal GET request
                window.location.replace(window.location.href);
            }
            else
            {
                showForbiddenAccessDialog(jqXHR.responseText);
            }
            break;
        case 403:
            //Forbidden
            var isWorkflowAjaxRequest = settings != null && settings.activityIndicator != null && settings.activityIndicator.isWorkflowAjaxRequest;
            const isInvalidSession = jqXHR.getResponseHeader("X-Forbidden-Reason") === "SessionChanged";

            if (isInvalidSession)
            {
                // If we have multiple requests outstanding and the user's session changed, don't spam them with popups
                if (invalidSessionDialogOpen)
                {
                    break;
                }
                invalidSessionDialogOpen = true;
                showForbiddenAccessDialog(jqXHR.responseText, isWorkflowAjaxRequest).always(() => { invalidSessionDialogOpen = false; });
            }
            else
            {
                showForbiddenAccessDialog(jqXHR.responseText, isWorkflowAjaxRequest);
            }
            break;
        case 500:
            //Server Error
            const log = logAjaxError(jqXHR);

            if (log.primaryKey && log.primaryKey > 0)
            {
                showErrorDialog("Internal Server Error", "There was an error processing your request (" + log.primaryKey + "):\n" + log.message);
            }
            else
            {
                showErrorDialog("Internal Server Error", "There was an error processing your request:\n" + log.message);
            }

            break;
    }
}

export function logAjaxError(jqXHR: JQuery.jqXHR)
{
    const log: AjaxErrorLog =
    {
        message: "Unknown error.",
        severity: "",
        primaryKey: null
    };

    if (jqXHR.responseText)
    {
        try
        {
            const errorData = JSON.parse(jqXHR.responseText);
            if (errorData !== null)
            {
                log.message = errorData.message;
                log.severity = errorData.severity;
                log.primaryKey = errorData.primaryKey;
                log.showViewLog = errorData.showViewLog;
            }
        }
        catch (ex)
        {
            log.message = "An additional error occurred while processing the error data.";
            console.warn("Unparsable error data", jqXHR.responseText);
        }
        let exceptionToReport = new SkywardException("A server-side error occurred");
        if (log.primaryKey)
        {
            exceptionToReport.details = JSON.stringify({ primaryKey: log.primaryKey });
        }
        else
        {
            exceptionToReport.details = JSON.stringify(log);
        }

        reportException(exceptionToReport);
    }

    return log;
}

function dialog(this: JQueryInput)
{
    const data = $(this).data();
    showErrorDialog(data.message, data.description);
}

function showForbiddenAccessDialog(responseText: string, isWorkflowAjaxRequest?: boolean)
{
    //if there's a workflow popup, pass button param to the call to showCriticalDialog, 
    //make the close button not just close the modal, but also the workflow popup

    let options = {};
    if (isWorkflowAjaxRequest)
    {
        // @ts-ignore workflow doesn't have a .d.ts and we don't want to import this file
        // This allows us to use this method without including it in the bundle for pages that don't have the workflow module, while still providing enhanced functionality for pages that do
        options = { afterClose: skyward.workflow?.closeWorkflowPopup };
    }

    return showErrorDialog("Forbidden Access", responseText ?? "You do not have the correct permissions to perform this task.", options) as unknown as JQuery.Promise<any>;
}